import React from 'react';
import { CSSTransition } from 'react-transition-group';
import './final.scss';

const Final = (props) => {
    return (
        <CSSTransition
            in={props.isGameStarted}
            timeout={2000}
            classNames='final'
            appear
        >
            <div className="welcome-page">
                <p>Let's talk about <strong>CKAN</strong></p>
            </div>
        </CSSTransition>
    )
};

export default Final;